import { z } from "zod";

export const updateGroupSchema = z
	.object({
		name: z.string().min(1).max(100).optional(),
		description: z.string().max(500).optional(),
		photo_url: z.url().optional(),
	})
	.strict();

export type UpdateGroupPayload = z.infer<typeof updateGroupSchema>;
